const $ = jQuery

function SmoothScroll () {
  $(document).on('click', 'a[href^="#ss-"]', function (event) {
    event.preventDefault()
    scroll($.attr(this, 'href'))
  })
}

function scroll (element) {
  $('html, body').animate({
    scrollTop: $(element).offset().top - getHeaderHeight()
  }, 800)
}

function getHeaderHeight () {
  let height = 0
  const HEADER = document.getElementById('main_header')
  HEADER && (height += HEADER.getBoundingClientRect().height)
  const ADMIN_BAR = document.getElementById('wpadminbar')
  ADMIN_BAR && (height += ADMIN_BAR.getBoundingClientRect().height)
  return height
}

module.exports = {
  SmoothScroll,
  scroll,
  getHeaderHeight
}